import React from "react";
import ArrowUp from "../../assets/icons/indicator-up.svg";
import ArrowDown from "../../assets/icons/indicator-down.svg";

const CheckboxDetailsComponent = ({
  setOpenDetails,
  openDetails,
  title = "Details",
  data = [],
  keyWord,
  isChecked,
  onChange = () => {},
}) => {
  return (
    <div className="my-4">
      <div className="invoice-basic-details-container my-auto d-flex justify-content-between align-items-center gap-2 cursor_pointer px-3">
        <div>
          <input
            type="checkbox"
            checked={isChecked}
            className="CheckBox"
            onChange={onChange}
          />
        </div>
        <div
          onClick={() => {
            if (openDetails.includes(keyWord)) {
              setOpenDetails(openDetails.filter((item) => item !== keyWord));
            } else {
              setOpenDetails([...openDetails, keyWord]);
            }
          }}
          className="w-100 d-flex align-items-center justify-content-between"
        >
          <label className="basic-title">{title}</label>
          <div>
            <span>
              {openDetails.includes(keyWord) ? (
                <img src={ArrowDown} />
              ) : (
                <img src={ArrowUp} />
              )}
            </span>
          </div>
        </div>
      </div>
      {openDetails.includes(keyWord) && (
        <div className="my-4 px-2">
          <div className="row">
            {data.map((item, index) => (
              <div
                key={index}
                className="col-sm-6 col-md-6 col-xxl-4 mx-4 mx-xl-0"
                style={{ maxWidth: "270px" }}
              >
                <h5 className="color_747f9e text-nowrap fs_14 fw_500 m-0">
                  {item.heading}
                </h5>
                <p
                  className={`fs_15 fn_Nunito fw_500 text-capitalize text-wrap`}
                >
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckboxDetailsComponent;
